var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03112 0.356839C6.58942 -0.118946 7.41058 -0.118946 7.96888 0.356839L8.91852 1.16611C9.15777 1.37 9.45524 1.49322 9.76858 1.51822L11.0123 1.61747C11.7435 1.67582 12.3242 2.25647 12.3825 2.98768L12.4818 4.23142C12.5068 4.54476 12.63 4.84223 12.8339 5.08148L13.6432 6.03112C14.1189 6.58942 14.1189 7.41058 13.6432 7.96888L12.8339 8.91852C12.63 9.15777 12.5068 9.45524 12.4818 9.76858L12.3825 11.0123C12.3242 11.7435 11.7435 12.3242 11.0123 12.3825L9.76858 12.4818C9.45524 12.5068 9.15777 12.63 8.91852 12.8339L7.96888 13.6432C7.41058 14.1189 6.58942 14.1189 6.03112 13.6432L5.08148 12.8339C4.84223 12.63 4.54476 12.5068 4.23142 12.4818L2.98768 12.3825C2.25647 12.3242 1.67582 11.7435 1.61747 11.0123L1.51822 9.76858C1.49322 9.45524 1.37 9.15777 1.16611 8.91852L0.356839 7.96888C-0.118946 7.41058 -0.118946 6.58942 0.356839 6.03112L1.16611 5.08148C1.37 4.84223 1.49322 4.54476 1.51822 4.23142L1.61747 2.98768C1.67582 2.25647 2.25647 1.67582 2.98768 1.61747L4.23142 1.51822C4.54476 1.49322 4.84223 1.37 5.08148 1.16611L6.03112 0.356839Z",
    fill: "#00ABC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33335 5.44434L6.22224 8.55545L4.66669 6.99989",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.016330f9c3b6ba24534527ee49c03b62.svg";
export { ForwardRef as ReactComponent };